import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import useLanguageTracker from 'hooks/useLanguageTracker';
import { useQuery } from 'hooks/apollo';
import { PROPERTY_QUERY } from '../queries';
import { FakeText, Card } from '@totalsoft/rocket-ui';
import PropertyGeneralDataContainer from './generalData/PropertyGeneralDataContainer';
import PropertyDetailListContainer from './propertyDetails/PropertyDetailListContainer';
import PropertyUserGroupsListContainer from './security/PropertyUserGroupsListContainer';

const PropertyContainer = ({ id, onChangePropertyTitle, onRedirect }) => {
  const { data, loading, refetch } = useQuery(PROPERTY_QUERY, {
    variables: { propertyId: id },
    skip: id === undefined || id === null
  });

  const onLanguageChange = useCallback(() => {
    refetch();
  }, [refetch]);

  useLanguageTracker({
    onChange: onLanguageChange
  });

  return loading ? (
    <Card>
      <FakeText lines={10} />
    </Card>
  ) : (
    <>
      <PropertyGeneralDataContainer data={data?.property} onRedirect={onRedirect} onChangePropertyTitle={onChangePropertyTitle} />
      {id !== null && id !== undefined && (
        <>
          <PropertyDetailListContainer propertyId={id} propertyTypeId={data?.property?.propertyTypeId} />
          <PropertyUserGroupsListContainer propertyId={id} data={data && data.property ? data.property.propertyUserGroups : []} />
        </>
      )}
    </>
  );
};

PropertyContainer.propTypes = {
  id: PropTypes.number,
  onChangePropertyTitle: PropTypes.func,
  onRedirect: PropTypes.func
};

export default PropertyContainer;
